/* @flow */

/* eslint-disable camelcase */
import * as React from 'react';
import styled from 'styled-components';
import { withRouter } from 'next/router';
// $FlowFixMe
import { Dropdown, Menu } from '@bijie/react-bnb';

import memoizeOne from '../../utils/memorizeOne';
import FlexBox, { BorderedFlexBox } from '../FlexBox';
import Tooltip from '../Tooltip';
import InnerOrderForms from './InnerOrderForms';
import Fee from './Fee';
import zIndexScale from '../../utils/zIndexScale';
import urlConfig from '../../config/urls';
import { getSupportLocale } from '../../utils/locales';
import CreateMarginAccount from '../Margin/CreateMarginAccount';
import TransferModal from '../Margin/TransferModal';
import BorrowRepayModal from '../Margin/BorrowRepayModal';
import { getLabel } from '../../utils/i18n';
import getRiskLevel from '../../utils/getRiskLevel';
import LoadingShade from '../LoadingShade';
import Icon from '../Icon';
import TradeRuleTip from '../TradeRule/TradeRuleTip';
import { createCookie } from '../../utils/cookies-browser';
import { fetchMaxBorrowAmount } from '../../actions/actionsSet/margin';

const Wrapper = styled(FlexBox)`
  margin: 4px 5px 0px;
  min-height: 274px;
  min-width: 500px;
  width:100%;
`;

const StyledMenu = styled(Menu)`
  margin-top: -6px;
  background: ${({ theme }) => theme.formsbg};
`;

const Tabs = styled.ul`
  display: flex;
  padding-left: 0;
  padding-bottom: 0;
  position: relative;
`;

const Tab = styled.li`
  align-items: baseline;
  background: ${({ theme, selected }) => selected ? theme.formsbg : theme.buttonbg};
  border: 1px solid ${({ theme }) => theme.border || '#eee'};
  border-bottom-color: ${({ theme, selected }) => selected ? theme.formsbg : theme.border || '#eee'};
  box-sizing: content-box;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  padding: 5px 14px;
  margin: 0;
  user-select: none;
  height: 22px;
  line-height: 22px;
  outline: 0;

  ${({ selected, theme }) => selected ? `
    position: relative;
    & > span {
      color: ${theme.highlight};
      font-weight bold;
    }
  ` : ''}

  ${({ selected }) => !selected ? `
    &:hover {
      filter: brightness(0.98);
      z-index: ${zIndexScale.tooltip};
    }
  ` : ''}

  &:not(:first-child) {
    margin-left: -1px;
  }
`;

const FutureTab = styled.li`
  font-family: ${({ theme }) => theme.fontIBMRegular};
  cursor: pointer;
  display: flex;
  padding: 5px 14px;
  margin: 0;
  user-select: none;
  &:hover .futures{
  color: #F0B90B;
  }
  &:hover .arrow {
  background: url(${require('./arrow-yellow.svg')}) no-repeat center;
  }
`;

const List = styled.ul`
  display: flex;
  position: relative;
  margin:auto;
  &:nth-child(-n+3) {
  }
`;

const ListItem = styled.li`
  margin-left:4px;
  height:28px;
  background:rgba(255,255,255,1);
  border:1px solid rgba(230, 230, 230, 1);
  border-radius:14px;
  color: ${({ theme, selected }) => selected ? theme.highlight : theme.fontColor};
  align-items: baseline;
  background: ${({ theme, selected }) => selected ? theme.formsbg : theme.buttonbg};
  border: 1px solid ${({ theme }) => theme.border || '#eee'};
  box-sizing: content-box;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  padding: 3px 10px;
  user-select: none;
  height: 22px;
  line-height: 22px;
  outline: 0;
  a {
    color: ${({ theme, selected }) => selected ? theme.highlight : theme.fontColor};
  }
`;

const MenuItem = styled.li`
  padding: 5px 16px !important;
  height:28px;
  background:rgba(255,255,255,1);
  color: ${({ theme, selected }) => selected ? theme.highlight : theme.fontColor};
  align-items: baseline;
  background: ${({ theme }) => theme.buttonbg};
  box-sizing: content-box;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  padding: 3px 10px;
  user-select: none;
  height: 22px;
  line-height: 22px;
  outline: 0;
    &:hover {
      background: ${({ theme }) => theme.formsbg};
    }
`;


const FormsFlexBox = styled(BorderedFlexBox)`
  display:flex;
  justify-content: 'space-between';
  background: ${({ theme }) => theme.formsbg};
  margin: -1px 0 0 0;
  font-size: 14px;
`;

const FormsFlexBoxLeft = styled.div`
  display:flex;
  height:45px;
  padding-left:10px;
   &:nth-child(-n+3) {
   }
`;

const FormsFlexBoxRight = styled.div`
  margin: auto 24px auto auto;
  color: ${({ theme }) => theme.buttonColorActive};
`;


const FormsFlexBox2 = styled(BorderedFlexBox)`
  background: ${({ theme }) => theme.formsbg};
  margin: -1px 0 0 0;
`;

const StopLimitSpan = styled.span`
  color: ${({ theme }) => theme.highlight};
  &:hover {
    color: ${({ theme }) => theme.highlight};
  }
`;

const HeaderFlexBox = styled(FlexBox)`
  background:${({ theme }) => theme.formsHeaderbg};
`;

const ModerateRisk = styled.span`
  position: relative;
  width:114px;
  height:12px;
  font-weight:400;
  line-height:20px;
`;

const Span = styled.span`
  margin-left: 10px;
  padding-left:10px;
  cursor:pointer;
  > a{
    color:#f0b90b;
  }
  border-left:1px solid ${({ theme }) => theme.border};
  &:hover{
    text-decoration: underline;
    }
`;

const CoeffIcon = styled.div`
display:inline-block;
font-family: ${({ theme }) => theme.fontIBMBold};
font-size: 12px;
font-weight: 500;
width: 24px;
height: 14px;
line-height: 11.5px;
padding: 2px 3px;
background: #F0B90B;
border-radius: 3px;
margin-left: 2px;
color: #212833;
`;

const ArrowRight = styled.div`
display: inline-block;
margin-left: 4px;
vertical-align: -6px;
width: 20px;
height: 20px;
background: url(${require('./arrow.svg')}) no-repeat center;
}
`;

const TipContent = styled.p``;

function array2Map(arr) {
  const tmpMap = {};
  arr.forEach(item => {
    tmpMap[item.asset] = item;
  });
  return tmpMap;
}

// memorize calculate result
const formatSymbolWithAllAsset = (marginAssets, assetsInfo) => {
  if (marginAssets.length > 0 && assetsInfo.length > 0) {
    const assetMap = array2Map(assetsInfo);
    return marginAssets.filter(item => assetMap[item.assetName]).map(item => {
      const {
        asset, assetName, free, logoUrl,
      } = assetMap[item.assetName];
      return {
        ...item,
        asset,
        assetName,
        logoUrl,
        maxTransferAmount: free,
      };
    });
  }
  return marginAssets;
};

const formatSymbolsWithUserAsset = (marginAssets, userAssets) => {
  if (marginAssets.length > 0 && userAssets.length > 0) {
    const assetMap = array2Map(userAssets);
    return marginAssets.filter(item1 => assetMap[item1.asset]).map(item => ({
      ...item,
      ...assetMap[item.asset],
    }));
  }
  return marginAssets;
};

const memoizedSymbolsWithUserAssets = memoizeOne(formatSymbolsWithUserAsset);
const memoizedSymbolsWithAllAsset = memoizeOne(formatSymbolWithAllAsset);


type Props = {
  i18n: Object,
  locale: string,
  base: any,
  pair: Array<any>,
  omitFee?: boolean,
  router: Object,
  isExistMarginAccount:boolean,
  userInfo: Object,
  allUserAssets:Array<any>,
  marginAssets:Array<any>,
  marginAccount:Object,
  setMarginStatus:Function,
  marginStatus: boolean,
  marginBorrow_BUY: boolean,
  marginBorrow_SELL: boolean,
  marginStopLimitOrOCOTab: boolean,
  tip:string,
  color:string,
  marginLevel:string,
  marginCoeff:Object,
  fetchMarginAccount: Function,
  fetchAllUserAssets:Function,
  setMarginForceUpdate: Function,
  isLoggedIn: boolean,
  fetched: boolean,
  userKYCInfo: Object,
  setMarginAccountMaxBorrowable:Function,
  setMarginAssetModeStart:Function,
  setMarginAssetModeEnd:Function,
  setMarginStopLimitOrOCOTab: Function,
};

type State = { selectedOrderType: string, selectedTradeType:string, symbols:Array<any>, color:string, tip:string, riskLevel:string };

export default
@withRouter
class MarginTabbedOrderForms extends React.PureComponent<Props, State> {
  static defaultProps = {
    router: {},
    omitFee: false,
  }

  _transferModalRef :Object = React.createRef()

  _borrowRepayModalRef:Object = React.createRef();

  _tick: any

  state = {
    selectedTradeType: 'exchange',
    selectedOrderType: 'limit',
    symbols: [],
    color: '',
    tip: '',
    riskLevel: '',
  }

  static getDerivedStateFromProps({
    allUserAssets,
    marginAssets,
    marginAccount: { userAssets },
    marginLevel,
    marginCoeff,
    marginStatus,
  }: Props) {
    const _marginAssets = memoizedSymbolsWithAllAsset(marginAssets, allUserAssets);
    const symbols = memoizedSymbolsWithUserAssets(_marginAssets, userAssets);
    return { selectedTradeType: marginStatus ? 'margin' : 'exchange', symbols, ...getRiskLevel(+marginLevel, marginCoeff) };
  }

  componentDidMount(): void {
    const { router: { query: { type: queryType } } } = this.props;
    if (queryType === 'margin') this.setState({ selectedTradeType: 'margin' });
  }

  componentWillUnmount(): void {
    if (this._tick) clearInterval(this._tick);
  }

  _onTradeTabChange = (ev: MouseEvent) => {
    const { setMarginStatus } = this.props;
    if (!(ev.currentTarget instanceof HTMLElement)) return;
    const { dataset } = ev.currentTarget;
    const { name: clickedOrderType } = dataset;
    const status = clickedOrderType === 'margin';
    setMarginStatus(status);
    this.setState({ selectedTradeType: clickedOrderType });
    window.localStorage.setItem('margin.status', status);
  }

  _onOrderTabChange = (ev: MouseEvent) => {
    if (!(ev.currentTarget instanceof HTMLElement)) return;
    const { setMarginStopLimitOrOCOTab } = this.props;
    const { dataset } = ev.currentTarget;
    const { name: clickedOrderType } = dataset;
    if (clickedOrderType === 'oco') {
      setMarginStopLimitOrOCOTab(true);
      createCookie('marginStopLimitOrOCOTab', true);
    }
    if (clickedOrderType === 'stop-limit') {
      setMarginStopLimitOrOCOTab(false);
      createCookie('marginStopLimitOrOCOTab', false);
    }
    this.setState({ selectedOrderType: clickedOrderType });
  }

  showTransfer = (asset:Object) => {
    this._transferModalRef.current.showModal(asset);
  }

  showBorrowRepay = (asset:Object) => {
    this.props.fetchMarginAccount();
    this._borrowRepayModalRef.current.showModal(asset);
  }

  _updateMarginAccount=(force:boolean) => {
    const {
      pair, marginStatus,
      marginBorrow_BUY,
      marginBorrow_SELL,
      setMarginAccountMaxBorrowable,
    } = this.props;
    if (force) {
      this.props.fetchMarginAccount();
      this.props.fetchAllUserAssets();
      if (marginStatus) {
        const [base, quote] = pair;
        const promises = [];
        if (marginBorrow_BUY) {
          promises.push(fetchMaxBorrowAmount(quote)
            .then(asset => setMarginAccountMaxBorrowable({ [quote]: asset })));
        }
        if (marginBorrow_SELL) {
          promises.push(fetchMaxBorrowAmount(base)
            .then(asset => setMarginAccountMaxBorrowable({ [base]: asset })));
        }
        Promise.all(promises);
      }
    }
  }

  render() {
    const {
      i18n,
      base,
      pair,
      omitFee,
      locale,
      userInfo: {
        isExistMarginAccount, mobileSecurity, gauth,
      },
      marginLevel,
      marginStopLimitOrOCOTab,
      isLoggedIn,
      fetched,
      userKYCInfo,
    } = this.props;
    const {
      selectedTradeType, selectedOrderType, symbols, color, tip, riskLevel,
    } = this.state;
    const asset = symbols.filter(s => s.asset === base)[0] || {};
    const stopLimitUrl = urlConfig.tooltip.stopLimit.replace('%locale', getSupportLocale(locale));
    const ocoUrl = urlConfig.tooltip.ocoUrl.replace('%locale', getSupportLocale(locale));
    const [b, q] = pair;
    const BTCUSDT = b === 'BTC' && q === 'USDT';

    const toolTipContent = selectedOrderType === 'oco' ? (
      <React.Fragment>
        <TipContent>
          {/* {i18n.stopLimitInfo || 'A Stop-Limit order is an order to buy or sell a coin once the price reaches a specified price.'} */}
          {getLabel('exchange-trade-ocoInfo', i18n)}
        </TipContent>
        {/*
            TODO: Use Localized links. There are 3 versions now,
                  but the locales used are different from we set before.
         */}
        <TipContent>
          <a
            href={ocoUrl}
            target="_blank"
            rel="noopener noreferrer"
            id={`${(selectedTradeType) === 'exchange' ?
              'TabbedOrderFormsMargin-a-exchangeOCOViewMore' : 'TabbedOrderFormsMargin-a-marginStopOCOViewMore'
            }`}
          >
            <StopLimitSpan>{getLabel('exchange-trade-viewMore', i18n)}</StopLimitSpan>
          </a>
        </TipContent>
      </React.Fragment>
    ) : (
      <React.Fragment>
        <TipContent>
          {/* {i18n.stopLimitInfo || 'A Stop-Limit order is an order to buy or sell a coin once the price reaches a specified price.'} */}
          {getLabel('exchange-trade-stopLimitInfo', i18n)}
        </TipContent>
        {/*
            TODO: Use Localized links. There are 3 versions now,
                  but the locales used are different from we set before.
         */}
        <TipContent>
          <a
            href={stopLimitUrl}
            target="_blank"
            rel="noopener noreferrer"
            id={`${(selectedTradeType) === 'exchange' ?
              'TabbedOrderFormsMargin-a-exchangeStopLimitViewMore' : 'TabbedOrderFormsMargin-a-marginStopLimitViewMore'
            }`}
          >
            <StopLimitSpan>{getLabel('exchange-trade-viewMore', i18n)}</StopLimitSpan>
          </a>
        </TipContent>
      </React.Fragment>
    );
    return (
      <Wrapper direction="column" {...this.props}>
        <HeaderFlexBox justify="space-between">
          <Tabs>
            <Tab
              data-name="exchange"
              selected={selectedTradeType === 'exchange'}
              onClick={this._onTradeTabChange}
            >
              <a id="TabbedOrderFormsMargin-a-exchange">
                <span>
                  {getLabel('exchange-trade-exchange', i18n)}
                </span>
              </a>
            </Tab>
            <Tab
              data-name="margin"
              selected={selectedTradeType === 'margin'}
              onClick={this._onTradeTabChange}
            >
              <a id="TabbedOrderFormsMargin-a-margin">
                <span>
                  {getLabel('exchange-trade-margin', i18n)}
                </span>
              </a>
            </Tab>
            {
              BTCUSDT ?
                <FutureTab>
                  <a href={`/${locale}/futures/BTCUSDT`} id="TabbedOrderFormsMargin-a-Future">
                    <span className="futures">
                      {getLabel('exchange-trade-futures', i18n, 'Futures')}
                    </span>
                    <CoeffIcon>
                      x20
                    </CoeffIcon>
                    <ArrowRight className="arrow" />
                  </a>
                </FutureTab>
                : null
            }
          </Tabs>
          <FlexBox>
            <TradeRuleTip pair={pair} />
            { omitFee ? null : <Fee /> }
          </FlexBox>
        </HeaderFlexBox>
        {isLoggedIn && !isExistMarginAccount && selectedTradeType === 'margin' ?
          <React.Fragment>
            {fetched ?
              <FormsFlexBox direction="row" flex="1">
                <CreateMarginAccount {...this.props} mobileSecurity={mobileSecurity} gauth={gauth} userKYCInfo={userKYCInfo} mode="row" />
              </FormsFlexBox>
              :
              <FormsFlexBox direcrtion="row" flex="1">
                <LoadingShade hidden={false} style={{ position: 'relative', margin: 'auto' }} />
              </FormsFlexBox>
            }
          </React.Fragment>
          :
          <React.Fragment>
            <FormsFlexBox direction="row">
              <FormsFlexBoxLeft>
                <List>
                  <ListItem
                    data-name="limit"
                    selected={selectedOrderType === 'limit'}
                    onClick={this._onOrderTabChange}
                  >
                    <a
                      id={`${(selectedTradeType) === 'exchange' ? 'TabbedOrderFormsMargin-a-exchangeLimit' : 'TabbedOrderFormsMargin-a-marginLimit'}`}
                    >
                      {getLabel('exchange-trade-LimitOrder', i18n)}
                    </a>
                  </ListItem>
                  <ListItem
                    data-name="market"
                    selected={selectedOrderType === 'market'}
                    onClick={this._onOrderTabChange}
                  >
                    <a
                      id={`${(selectedTradeType) === 'exchange' ? 'TabbedOrderFormsMargin-a-exchangeMarket' : 'TabbedOrderFormsMargin-a-marginMarket'}`}
                    >
                      {getLabel('exchange-trade-MarketOrder', i18n)}
                    </a>
                  </ListItem>

                  <React.Fragment>
                    <Dropdown
                      overlay={
                        <StyledMenu>
                          <MenuItem
                            data-name="oco"
                            selected={selectedOrderType === 'oco'}
                            onClick={this._onOrderTabChange}
                          >
                            <span
                              id={`${(selectedTradeType) === 'exchange' ? 'TabbedOrderFormsMargin-a-exchangeOCO' : 'TabbedOrderFormsMargin-a-marginOCO'}`}
                            >
                              {getLabel('exchange-trade-OCO', i18n)}
                            </span>
                          </MenuItem>
                          <MenuItem
                            data-name="stop-limit"
                            selected={selectedOrderType === 'stop-limit'}
                            onClick={this._onOrderTabChange}
                          >
                            <span
                              id={`${(selectedTradeType) === 'exchange' ?
                                'TabbedOrderFormsMargin-a-exchangeStopLimit' : 'TabbedOrderFormsMargin-a-marginStopLimit'}`}
                            >
                              {getLabel('exchange-trade-StopLimit', i18n)}
                            </span>
                          </MenuItem>
                        </StyledMenu>}
                      trigger="click"
                    >
                      <ListItem
                        data-name="oco"
                        selected={selectedOrderType === 'oco' || selectedOrderType === 'stop-limit'}
                      >
                        <span>
                          {/* // todo ssr */}
                          {marginStopLimitOrOCOTab ?
                            <React.Fragment>
                              {
                                getLabel('exchange-trade-OCO', i18n)
                              }
                              &nbsp;&nbsp;
                              <Tooltip>{toolTipContent}</Tooltip>
                              &nbsp;&nbsp;
                            </React.Fragment>
                            :
                            <React.Fragment>
                              {
                                getLabel('exchange-trade-StopLimit', i18n)
                              }
                              &nbsp;&nbsp;
                              <Tooltip>{toolTipContent}</Tooltip>
                              &nbsp;&nbsp;
                            </React.Fragment>
                          }
                        </span>
                        <Icon type="arrow-d" size={12} color="#848E9C" style={{ transform: 'scale(0.8)' }} />
                      </ListItem>
                    </Dropdown>
                  </React.Fragment>


                </List>
              </FormsFlexBoxLeft>
              {isLoggedIn && selectedTradeType === 'margin' ?
                <FormsFlexBoxRight>
                  <ModerateRisk color={color}>
                    {`${getLabel(tip, i18n)}:${marginLevel}`}
                    &nbsp;&nbsp;
                    {riskLevel === 'moderateRisk' ? <Tooltip iconClass="prompt">{getLabel('exchange-trade-closelyMonitorYourAccount', i18n)}</Tooltip> : null}
                    {riskLevel === 'highRisk' ? <Tooltip iconClass="prompt">{getLabel('exchange-trade-saveOrDown', i18n)}</Tooltip> : null}
                    {/* TODO */}
                  </ModerateRisk>
                  <Span onClick={() => this.showTransfer(asset)}>
                    <a id="TabbedOrderFormsMargin-a-MarginTransfer">{getLabel('exchange-trade-Transfer', i18n)}</a>
                  </Span>
                  <Span onClick={() => this.showBorrowRepay(asset)}>
                    <a id="TabbedOrderFormsMargin-a-MarginBorrow">{getLabel('exchange-borrowRepayModal-borrow', i18n)}</a>
                  </Span>
                  <TransferModal
                    ref={this._transferModalRef}
                    i18n={i18n}
                    userAssets={symbols}
                    callback={force => this._updateMarginAccount(force)}
                  />
                  <BorrowRepayModal
                    ref={this._borrowRepayModalRef}
                    i18n={i18n}
                    userAssets={symbols}
                    callback={force => this._updateMarginAccount(force)}
                  />
                </FormsFlexBoxRight>
                : null}
            </FormsFlexBox>
            <FormsFlexBox2 direction="row" flex="1">
              <InnerOrderForms
                i18n={i18n}
                base={base}
                pair={pair}
                tradeType={selectedTradeType}
                orderType={selectedOrderType}
              />
            </FormsFlexBox2>
          </React.Fragment>
          }
      </Wrapper>
    );
  }
}
